.as{padding:0.5rem;}